"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/www/wwwroot/check/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.string.pad-start");
var _request = _interopRequireDefault(require("@/utils/request"));
var _request2 = _interopRequireDefault(require("@/utils/request4"));
var _RestTable = _interopRequireDefault(require("@/components/RestTable.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _formatMixin = require("@/utils/formatMixin");
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _auth = require("@/utils/auth");
var _request3 = _interopRequireDefault(require("@/utils/request5"));
var _qrcode = _interopRequireDefault(require("qrcode"));
var _default = exports.default = {
  components: {
    RestTable: _RestTable.default,
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  data: function data() {
    return {
      chargeform: {},
      currentName: '',
      //风控名称
      currentType: '',
      // 风控类型
      currentPrice: '',
      // 风控价格
      user_id: 0,
      user_info: {
        photoBack: '',
        photoFront: ''
      },
      // 顶部搜索框form数据
      formInline: {
        start_time: '',
        end_time: ''
      },
      //   dialogVisiblerisk: false,
      datenum: [],
      money: 0,
      // 商家余额
      moneyList: {
        count: 0
      },
      // 调用记录
      listQuery: {
        page: 1,
        page_size: 10
      },
      listLoading: false,
      deviceType: 'desktop',
      // 设备类型: mobile, tablet, desktop
      showPhoto: false,
      action: '/api/safe/posts/',
      document: {},
      qrImg: "",
      showQrcode: false,
      qrcodetype: 1
    };
  },
  created: function created() {
    if (this.$route.query.user_id) {
      console.log(this.$route.query.user_id);
      this.user_id = this.$route.query.user_id;
      this.getFengKongUser();
    } else {
      console.log('no user_id');
      this.getMoneyList();
    }
    this.getCharge();

    // 添加这一行来设置正确的action路径
    this.action = "".concat(process.env.VUE_APP_BASE_API, "/safe/posts/");
  },
  computed: {
    start_time: function start_time() {
      return this.datenum[0] ? this.formatDate(this.datenum[0]) : '';
    },
    end_time: function end_time() {
      return this.datenum[1] ? this.formatDate(this.datenum[1]) : '';
    }
  },
  mounted: function mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    getCharge: function getCharge() {
      var _this = this;
      (0, _request.default)({
        url: "/system/shopConfig/getConfig/",
        method: 'get',
        params: {
          shop_id: this.$user.data.shop
        }
      }).then(function (response) {
        if (response.data) {
          _this.chargeform = response.data;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_token: function get_token(type) {
      var _this2 = this;
      (0, _request3.default)({
        url: "/get_token",
        method: 'post',
        data: {
          key: this.chargeform.key,
          secret: this.chargeform.key_secret
        }
      }).then(function (res) {
        console.log(res);
        (0, _auth.setTokenInfo)('apiToken', res.token, 3);
        if (type == 1) {
          _this2.setfengkong(res.token);
        }
        if (type == 2) {
          _this2.setSignUrl(res.token);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getFengKongUser: function getFengKongUser() {
      var _this3 = this;
      (0, _request.default)({
        url: "/system/shopConfig/getZhengXinUserInfo/",
        method: 'put',
        data: {
          shop_id: this.$user.data.shop,
          user_id: this.user_id
        }
      }).then(function (response) {
        if (response.data.data) {
          _this3.user_info = response.data.data;
          _this3.getMoneyList();
        } else {
          _this3.user_id = 0;
        }
        _this3.listLoading = false;
      });
    },
    // 格式化日期,需要加上时分秒的数据
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
      var day = String(date.getDate()).padStart(2, '0');
      var hour = String(date.getHours()).padStart(2, '0');
      var minute = String(date.getMinutes()).padStart(2, '0');
      var second = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minute, ":").concat(second);
    },
    resetFilter: function resetFilter() {
      this.formInline.start_time = '';
      this.formInline.end_time = '';
      this.datenum = [];
      this.getMoneyList();
    },
    // 获取划扣流水——done
    getMoneyList: function getMoneyList() {
      var _this4 = this;
      this.listLoading = true;
      // 王工封装
      // type 2 为支付宝账号流水
      (0, _request.default)({
        url: "/system/shopConfig/getGongZheng/",
        method: 'put',
        data: {
          page: this.listQuery.page,
          page_size: this.listQuery.page_size,
          shop_id: this.$user.data.shop,
          user_id: this.user_id,
          start_time: this.start_time,
          end_time: this.end_time
        }
      }).then(function (response) {
        if (response.data) {
          _this4.moneyList = response.data.data;
        }
        _this4.listLoading = false;
      });
    },
    handleClick: function handleClick(url) {
      window.open(url);
    },
    goto: function goto(url) {
      this.$router.push({
        path: url
      });
    },
    showEwn: function () {
      var _showEwn = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
        var qrImg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _qrcode.default.toDataURL(url);
            case 2:
              qrImg = _context.sent;
              //   this.showQrcode = true
              this.$message({
                dangerouslyUseHTMLString: true,
                message: '<img style="width:200px;height:200px" src="' + qrImg + '"></img>',
                duration: 0,
                showClose: true
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function showEwn(_x) {
        return _showEwn.apply(this, arguments);
      }
      return showEwn;
    }()
  }
};